import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login.tsx";
import Dashboard from "./components/Dashboard.tsx"; 

// --- COMPONENTE GUARDIA DE SEGURIDAD ---
// Este componente protege la ruta. Si no hay "token", te saca.
const RutaProtegida = ({ children }) => {
  const token = localStorage.getItem("token");
  
  // Si no hay token, al Login
  if (!token || token === "undefined" || token === "null") {
    return <Navigate to="/login" replace />;
  }
  // Si hay token, muestra la pantalla (Dashboard)
  return children;
};

function App() {
  // Título de la pestaña del navegador
  document.title = "MyFintrax";

  return (
    <BrowserRouter>
      <Routes>
        {/* RUTA PÚBLICA */}
        <Route path="/login" element={<Login />} />

        {/* RUTA PRIVADA (Protegida por Token) */}
        <Route
          path="/"
          element={
            <RutaProtegida>
              <Dashboard />
            </RutaProtegida>
          }
        />

        {/* CUALQUIER OTRA RUTA -> AL HOME (Que verificará el token) */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;